export default __webpack_public_path__ + "static/media/cat-4-4.6c0454b3.png";